import React, { useMemo } from 'react';
import { DetailsTabs } from 'features/sendouts/components/shared';
import strings from 'strings';

import { SendoutActivityLogsTabContent } from './SendoutActivityLogsTabContent';
import { SendoutAttachmentsTabContent } from './SendoutAttachmentsTabContent';
import { SendoutInterviewsTabContent } from './SendoutInterviewsTabContent';
import { SendoutNotesTabLoader } from './SendoutNotesTab';

const TAB_PANEL_PADDING_EXCLUDED_IDS = ['ActivityLogs'];

const buildTabs = ({
  sendoutId,
  canManageSendout,
  onScheduleInterview,
  onViewInterviewDetails
}) => [
  {
    id: strings.sendoutsV2.drawers.tabs.interviews.title,
    label: strings.sendoutsV2.drawers.tabs.interviews.title,
    view: (
      <SendoutInterviewsTabContent
        sendoutId={sendoutId}
        onScheduleInterview={onScheduleInterview}
        onViewInterviewDetails={onViewInterviewDetails}
      />
    )
  },
  {
    id: strings.sendoutsV2.drawers.tabs.attachments.title,
    label: strings.sendoutsV2.drawers.tabs.attachments.title,
    view: <SendoutAttachmentsTabContent sendoutId={sendoutId} />
  },
  {
    id: strings.sendoutsV2.drawers.tabs.emails.title,
    label: strings.sendoutsV2.drawers.tabs.emails.title,
    view: <div>Emails Content</div> // TODO: Create Emails Tab Content
  },
  {
    id: 'ActivityLogs',
    label: strings.sendoutsV2.drawers.tabs.activityLogs.title,
    view: <SendoutActivityLogsTabContent sendoutId={sendoutId} />
  },
  {
    id: strings.sendoutsV2.drawers.tabs.notes.title,
    label: strings.sendoutsV2.drawers.tabs.notes.title,
    view: <SendoutNotesTabLoader sendoutId={sendoutId} canManageSendout={canManageSendout} />
  }
];

export const SendoutDetailsTabs = ({
  sendoutId,
  canManageSendout,
  onScheduleInterview,
  onViewInterviewDetails
}) => {
  const tabs = useMemo(
    () =>
      buildTabs({
        sendoutId,
        canManageSendout,
        onScheduleInterview,
        onViewInterviewDetails
      }),
    [sendoutId, canManageSendout, onScheduleInterview, onViewInterviewDetails]
  );

  return (
    <DetailsTabs
      initialTab={tabs[0].id}
      tabPanelPaddingExcludedIds={TAB_PANEL_PADDING_EXCLUDED_IDS}
      tabs={tabs}
    />
  );
};
